/**
 * Ranges for different viewport widths used by the Design System.
 */
export const viewportWidth = {
  small: { min: 0, max: 767 },
  medium: { min: 768, max: 1399 },
  large: { min: 1400, max: Infinity },
} as const;

/**
 * Media queries for different viewport widths. Note that both `up` and `down` are inclusive.
 * For example, `mediaQuery.medium.up` targets viewports larger than 768px, while `mediaQuery.medium.down`
 * targets viewports 1399px and smaller, both including the medium viewport.
 */
export const mediaQuery = {
  small: {
    /**
     * Small viewports: 0px - 767px
     */
    down: `@media screen and (max-width: ${viewportWidth.small.max}px)`,
  },
  medium: {
    /**
     * Medium and small viewports: 0px - 1399px
     */
    down: `@media screen and (max-width: ${viewportWidth.medium.max}px)`,
    /**
     * Medium viewport: 768px - 1399px
     */
    only: `@media screen and (min-width: ${viewportWidth.medium.min}px) and (max-width: ${viewportWidth.medium.max}px)`,
    /**
     * Medium and large viewports: 768px and larger
     */
    up: `@media screen and (min-width: ${viewportWidth.medium.min}px)`,
  },
  large: {
    /**
     * Large viewport: 1400px and larger
     */
    up: `@media screen and (min-width: ${viewportWidth.large.min}px)`,
  },
} as const;
